export interface ZzzfunNavItem {
  id: string;
  label: string;
}

export const zzzfunNavItems: ZzzfunNavItem[] = [
  { id: 'zzzfun-home', label: '首页' },
  { id: 'zzzfun-features', label: '功能特色' },
  { id: 'zzzfun-screenshots', label: '截图预览' },
  { id: 'zzzfun-platforms', label: '支持平台' },
  { id: 'zzzfun-faq', label: '常见问题' },
];

/** 平滑滚动到指定区块的最上方（考虑固定页头高度） */
export function scrollToZzzfunSection(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  const headerOffset = 80;
  const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
  window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
}